import {useContext} from "react";

import {UserContext} from "../../contexts";

export function useUserContext() {
    return useContext(UserContext);
}
